import { render, staticRenderFns } from "./FloatingDialCustom.vue?vue&type=template&id=374f1c0a&scoped=true&"
import script from "./FloatingDialCustom.vue?vue&type=script&lang=js&"
export * from "./FloatingDialCustom.vue?vue&type=script&lang=js&"
import style0 from "./FloatingDialCustom.vue?vue&type=style&index=0&id=374f1c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f1c0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpeedDial } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSpeedDial})
